export type GetHttpProps = {
  gatewayAddress: string;
  apiConnectionTimeout?: number | null;
  requestHeaders?: { [key: string]: string } | null;
};

export enum CacheOptions {
  Enabled = 'force-cache',
  Disabled = 'no-store',
}

export type HttpClientOptions = {
  baseURL?: string;
  headers?: HeadersInit;
  timeout?: number;
  credentials?: RequestCredentials;
  cache?: CacheOptions;
  next?: { revalidate: number };
};

export type HttpClientResponse<T> = {
  headers: Headers | null;
  status: number | null;
  data: T | null;
  // TODO: Fix that
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any | null;
  // TODO: Fix that
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  exception: any | null;
};
